import React from 'react';
import { FaStethoscope, FaHeart, FaUserMd } from 'react-icons/fa';
import { motion } from 'framer-motion';
import * as S from './Hero.styles';

const Hero: React.FC = () => {
  const handleContactClick = () => {
    const contactSection = document.getElementById('contacto');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <S.HeroSection id="inicio">
      <S.HeroBackground />
      <S.HeroContent>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <S.HeroTitle as="h1" className="hero-title-contrast">
            Dra. Suni Wiphala Chipana Flores
          </S.HeroTitle>
          <S.HeroSubtitle>
            Medicina Integral con Enfoque en Salud Pública Comunitaria
          </S.HeroSubtitle>
          <S.HeroDescription>
            Formación integral en prevención, promoción, manejo y rehabilitación de la salud. 
            Especializado en el acompañamiento personalizado de pacientes con un enfoque 
            integral y humanizado.
          </S.HeroDescription>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <S.FeaturesGrid>
            <S.FeatureItem>
              <S.FeatureIcon>
                <FaStethoscope />
              </S.FeatureIcon>
              <S.FeatureText>Medicina Integral</S.FeatureText>
            </S.FeatureItem>
            <S.FeatureItem>
              <S.FeatureIcon>
                <FaHeart />
              </S.FeatureIcon>
              <S.FeatureText>Atención Personalizada</S.FeatureText>
            </S.FeatureItem>
            <S.FeatureItem>
              <S.FeatureIcon>
                <FaUserMd />
              </S.FeatureIcon>
              <S.FeatureText>Experiencia Profesional</S.FeatureText>
            </S.FeatureItem>
          </S.FeaturesGrid>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          <S.CTASection>
            <S.PrimaryButton onClick={handleContactClick}>
              Agendar Consulta
            </S.PrimaryButton>
            <S.SecondaryButton onClick={() => document.getElementById('servicios')?.scrollIntoView({ behavior: 'smooth' })}>
              Conocer Servicios
            </S.SecondaryButton>
          </S.CTASection>
        </motion.div>
      </S.HeroContent>
    </S.HeroSection>
  );
};

export default Hero;